import GoldenRatioContainer from '../shared/GoldenRatioContainer';

const SmartListsSkeleton = () => (
  <GoldenRatioContainer className="max-sm:mx-0">
    <div className="min-h-screen bg-base-200" role="status" aria-label="Loading Smart Lists">
      <div className="w-full">
        <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 mb-4">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Smart Lists</h1>
          <div aria-hidden="true">
            <div className="skeleton motion-reduce:animate-none h-4 w-64 max-w-full mb-4" />
            <div className="mb-4 flex flex-nowrap gap-2 overflow-x-hidden py-1 sm:flex-wrap sm:py-0">
              {[0, 1, 2].map(index => (
                <div key={index} className="skeleton motion-reduce:animate-none h-8 w-14 rounded-full" />
              ))}
            </div>
            <div className="space-y-3">
              {[0, 1, 2].map(index => (
                <div key={index} className="bg-gray-50 rounded-xl p-4">
                  <div className="flex items-start justify-between gap-4 mb-2">
                    <div className="skeleton motion-reduce:animate-none h-5 w-48 max-w-full" />
                    <div className="flex shrink-0 gap-2">
                      <div className="skeleton motion-reduce:animate-none h-5 w-5 rounded-full" />
                      <div className="skeleton motion-reduce:animate-none h-5 w-5 rounded-full" />
                    </div>
                  </div>
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                    <div className="skeleton motion-reduce:animate-none h-4 w-16" />
                    <div className="skeleton motion-reduce:animate-none h-4 w-8" />
                    <div className="skeleton motion-reduce:animate-none h-4 w-28" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </GoldenRatioContainer>
);

export default SmartListsSkeleton;
